import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./modules/user";
import authReducer from "./modules/authSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
  },
});

export default store;
